import { render, staticRenderFns } from "./AccountMenuIcon.vue?vue&type=template&id=29642348"
import script from "./AccountMenuIcon.vue?vue&type=script&lang=js"
export * from "./AccountMenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports